<!-- Tabs buttons -->
<div class="flex gap-[1px]">
  <!-- Tabs button -->
  @for (tab of tabs; track tab; let i = $index) {
    <div
      (click)="onSelectTab(tab, i)"
      class="flex items-center justify-center bg-neutral-focus w-[248px] h-[64px] px-4 rounded-t-xl cursor-pointer"
      [ngClass]="{ '!bg-white': tab.selected }"
      >
      <ng-container
        *ngTemplateOutlet="tab.titleTemplate; context: { tab }"
      ></ng-container>
    </div>
  }
</div>

<!-- Projected tabs content -->
<ng-content></ng-content>
